const JudgeOnboardingStep0 = 0
const JudgeOnboardingStep1 = 1
const JudgeOnboardingStep2 = 2
const JudgeOnboardingStep3 = 3
const JudgeOnboardingStep4 = 4

const JudgeOnboardingSteps = [JudgeOnboardingStep0, JudgeOnboardingStep1, JudgeOnboardingStep2, JudgeOnboardingStep3, JudgeOnboardingStep4]

export default {
  data: function () {
    return {
      JudgeOnboardingStep0,
      JudgeOnboardingStep1,
      JudgeOnboardingStep2,
      JudgeOnboardingStep3,
      JudgeOnboardingStep4,
      JudgeOnboardingSteps
    }
  }
}
